import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const HTML_BUTTONS = {
  alignment: `${Node_Type.HTML}.alignment`,
  edit: `${Node_Type.HTML}.edit`,
  width: `${Node_Type.HTML}.width`,
  height: `${Node_Type.HTML}.height`
};
export {
  HTML_BUTTONS
};
//# sourceMappingURL=consts.js.map
